
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("fv5g4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("61JdP")).default);
$parcel$export(module.exports, "jiraHomePageRightSidePanelResource", () => (parcelRequire("7z3So")).jiraHomePageRightSidePanelResource);

var $61JdP = parcelRequire("61JdP");

var $7z3So = parcelRequire("7z3So");

});
parcelRegister("61JdP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ce59da8626845ff$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $buJlM = parcelRequire("buJlM");

var $7z3So = parcelRequire("7z3So");

var $1V1OO = parcelRequire("1V1OO");
const $1ce59da8626845ff$var$RightSidePanelContainer = ()=>{
    const { queryReference: queryReference } = (0, $buJlM.useRelayResource)((0, $7z3So.jiraHomePageRightSidePanelResource));
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1V1OO.RightSidePanel), {
        queryReference: queryReference
    });
};
var $1ce59da8626845ff$export$2e2bcd8739ae039 = $1ce59da8626845ff$var$RightSidePanelContainer;

});
parcelRegister("1V1OO", function(module, exports) {

$parcel$export(module.exports, "RightSidePanel", () => $23cc6f884e53b76d$export$8912e7216438ef75);

var $2rkVF = parcelRequire("2rkVF");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $lgxha = parcelRequire("lgxha");

var $lwEXu = parcelRequire("lwEXu");

var $14cXh = parcelRequire("14cXh");
var $hO8H1 = parcelRequire("hO8H1");

var $h4Fhh = parcelRequire("h4Fhh");

var $bgCvx = parcelRequire("bgCvx");

var $fDZ6r = parcelRequire("fDZ6r");

var $1ybV0 = parcelRequire("1ybV0");

var $a3RN9 = parcelRequire("a3RN9");

var $fz8wa = parcelRequire("fz8wa");

var $5cOjU = parcelRequire("5cOjU");

var $bKT2R = parcelRequire("bKT2R");

var $7QPhl = parcelRequire("7QPhl");
const $23cc6f884e53b76d$var$isBroadcastWidgetEnabled = ()=>false;
const $23cc6f884e53b76d$export$8912e7216438ef75 = ({ queryReference: queryReference })=>{
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $fz8wa.useApplicationPermissions)();
    /* eslint-disable jira/relay/must-colocate-fragment-spreads */ const rootQueryRef = (0, $iWLL0.usePreloadedQuery)((0, $2rkVF.default), queryReference);
    const onSuccess = (0, $fDZ6r.useExperienceSuccess)((0, $bKT2R.RIGHT_SIDE_PANEL_EXPERIENCE));
    const [showSkipLink, setShowSkipLink] = (0, $eUqFw.useState)(false);
    const containerRef = (0, $eUqFw.useCallback)((node)=>{
        if (!node) {
            setShowSkipLink(false);
            return;
        }
        if (typeof ResizeObserver !== 'undefined') {
            const resizeObserver = new ResizeObserver((entries)=>{
                const [{ contentRect: contentRect }] = entries;
                setShowSkipLink(contentRect.width > 0);
            });
            resizeObserver.observe(node);
        }
    }, []);
    const changeboardingWidget = (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hO8H1.useChangeboardingBroadcastWidget)() : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($23cc6f884e53b76d$var$Container, {
        id: "jira-home-side-panel",
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5cOjU.NbaExperimentCards), null), showSkipLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QPhl.JiraHomeSidePanelSkipLink), null), $23cc6f884e53b76d$var$isBroadcastWidgetEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a3RN9.WidgetWithErrorBoundary), {
        queryReference: rootQueryRef
    }), changeboardingWidget?.isEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $14cXh.AsyncChangeboardingWidget), null), hasServiceDeskAccess && (0, $1ybV0.ff)('eoc-who-is-on-call-widget_dtqxx') && shouldUseJSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bgCvx.AsyncWhoIsOnCallWidget), null), hasServiceDeskAccess && (0, $1ybV0.ff)('alerts-list-widget-on-your-work_kn81n') && shouldUseJSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lwEXu.AsyncAlertListWidget), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: onSuccess
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23cc6f884e53b76d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "aside", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9842n _kqsw1if8 _4t3i1wug _bfhkzxtc _1pbykb7n _18m91wug _1e0c1txw _2lx21bp4 _4cvr1y6m _1yt4xqf6 _zulppxbi _vchhusvi _fiawglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lwEXu", function(module, exports) {

$parcel$export(module.exports, "AsyncAlertListWidget", () => $16d0f0bca085cf70$export$756f8f797887224c);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $16d0f0bca085cf70$var$LazyAlertListWidget = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("lfsvF")).then(({ AlertListWidget: AlertListWidget })=>AlertListWidget), {
    moduleId: "./src/packages/eoc/alert-list-widget/src/main.tsx"
});
const $16d0f0bca085cf70$export$756f8f797887224c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "eoc.alert-list-widget",
        packageName: "eoc-alert-list-widget",
        fallback: "unmount",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-eoc-alert-list-widget",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16d0f0bca085cf70$var$LazyAlertListWidget, null)));

});
parcelRegister("lfsvF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('lRI66')
        ]);
        const value = parcelRequire('6QnZS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("lRI66")
    ]).then(()=>parcelRequire('6QnZS'));
}

});


parcelRegister("14cXh", function(module, exports) {

$parcel$export(module.exports, "AsyncChangeboardingWidget", () => $0783bf3927b76228$export$18b081c0b87ff753);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $0783bf3927b76228$var$LazyChangeboardingWidget = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("mYrV9")).then(({ BroadcastWidget: BroadcastWidget })=>BroadcastWidget), {
    moduleId: "./src/packages/eoc/changeboarding/src/ui/broadcast-widget/index.tsx"
});
const $0783bf3927b76228$export$18b081c0b87ff753 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "eoc.changeboarding",
        packageName: "jiraEocChangeboarding",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-eoc-changeboarding",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0783bf3927b76228$var$LazyChangeboardingWidget, null)));

});
parcelRegister("mYrV9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4ZDF5');
        const value = parcelRequire('6oL5p');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4ZDF5").then(()=>parcelRequire('6oL5p'));
}

});


parcelRegister("hO8H1", function(module, exports) {

$parcel$export(module.exports, "useChangeboardingBroadcastWidget", () => $1652a5c028ac88c9$export$bc42a1c2f5132de5);

var $eUqFw = parcelRequire("eUqFw");

var $h4Fhh = parcelRequire("h4Fhh");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $hhjRL = parcelRequire("hhjRL");
const $1652a5c028ac88c9$export$bc42a1c2f5132de5 = ()=>{
    const { data: data, error: error } = (0, $hhjRL.useOgConsolidationUserState)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, $h4Fhh.useOgTenantInfo)();
    const isEnabled = Boolean((isAdmin || isSiteAdmin) && // Tenant info
    !tenantInfoError && isTransitionEligible && // User state
    !error && data && !data.isBroadcastWidgetDismissed);
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: isEnabled
        }), [
        isEnabled
    ]);
};

});

parcelRegister("bgCvx", function(module, exports) {

$parcel$export(module.exports, "AsyncWhoIsOnCallWidget", () => $d17667728eca5633$export$9d029d9368b19365);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $d17667728eca5633$var$LazyWhoIsOnCallWidget = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6Rbz4")).then(({ WhoIsOnCallWidget: WhoIsOnCallWidget })=>WhoIsOnCallWidget), {
    moduleId: "./src/packages/eoc/who-is-on-call-widget/src/main.tsx"
});
const $d17667728eca5633$export$9d029d9368b19365 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-eoc-who-is-on-call-widget",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d17667728eca5633$var$LazyWhoIsOnCallWidget, null));

});
parcelRegister("6Rbz4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('lvdu6')
        ]);
        const value = parcelRequire('i1UUE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("lvdu6")
    ]).then(()=>parcelRequire('i1UUE'));
}

});


parcelRegister("a3RN9", function(module, exports) {

$parcel$export(module.exports, "WidgetWithErrorBoundary", () => $b0def58b912e1344$export$5374d13fbe4efd69);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");


var $gazjn = parcelRequire("gazjn");
const $b0def58b912e1344$export$5374d13fbe4efd69 = ({ queryReference: queryReference })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $2491eac17b51377d$export$782903d5feb28a0a),
        packageName: (0, $2491eac17b51377d$export$b8b9d90f9e5bd72b),
        teamName: (0, $2491eac17b51377d$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-home-broadcast-widget",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gazjn.Widget), {
        queryReference: queryReference
    })));

});
const $2491eac17b51377d$export$782903d5feb28a0a = 'broadcastWidget';
const $2491eac17b51377d$export$b8b9d90f9e5bd72b = 'jiraHomeBroadcastWidget';
const $2491eac17b51377d$export$d57b6b390e78d90f = 'gravity';
const $2491eac17b51377d$export$33f599f0fcf9ffb1 = 'dismissErrorFlagId';
const $2491eac17b51377d$export$b0557d7f6549d5d6 = 'jiraHomeBroadcastOnDismissError';
const $2491eac17b51377d$export$3cf048f5f09bc0bd = 'jiraHomeBroadcastOnDismissMutationError';
const $2491eac17b51377d$export$78cb3b5fdca09232 = '/admin/billing/applications/change-edition/jira-software.ondemand';

parcelRegister("gazjn", function(module, exports) {

$parcel$export(module.exports, "Widget", () => $4570d88f0f9c87a7$export$a829527ff4e4114a);

var $4mmGE = parcelRequire("4mmGE");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $8B2FA = parcelRequire("8B2FA");

var $9zT4Z = parcelRequire("9zT4Z");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aiyU2 = parcelRequire("aiyU2");


var $61Upl = parcelRequire("61Upl");

var $adN3r = parcelRequire("adN3r");
const $4570d88f0f9c87a7$export$a829527ff4e4114a = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dismiss: dismiss, isDismissLoading: isDismissLoading } = (0, $adN3r.useDismissBroadcast)();
    const broadcastData = (0, $iWLL0.useFragment)((0, $4mmGE.default), queryReference);
    const broadcastMessages = (0, $eUqFw.useMemo)(()=>{
        if (broadcastData?.jira?.allJiraUserBroadcastMessages?.edges) {
            const { edges: edges } = broadcastData.jira.allJiraUserBroadcastMessages;
            if (Array.isArray(edges) && edges.length) return edges.filter((edge)=>{
                if (edge?.node) {
                    const { shouldDisplay: shouldDisplay } = edge.node ?? {};
                    return Boolean(shouldDisplay);
                }
                return false;
            });
        }
        return [];
    }, [
        broadcastData
    ]);
    if (!broadcastMessages.length) return null;
    const tryPremiumButtonClickedEvent = {
        href: (0, $2491eac17b51377d$export$78cb3b5fdca09232),
        actionSubjectId: 'yourWorkUpsellTryPremiumButton',
        attributes: {
            namespaces: 'navigationNextScreen.jiraHomeScreen.jiraHomeScreen'
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, broadcastMessages.map(({ node: node })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8B2FA.PromotionalCard), {
            key: node?.id,
            header: formatMessage((0, $61Upl.default).header),
            description: formatMessage((0, $61Upl.default).cardDescription),
            primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9zT4Z.ExternalLinkWithAnalytics), tryPremiumButtonClickedEvent, formatMessage((0, $61Upl.default).ctaLink)),
            reason: formatMessage((0, $61Upl.default).footerTooltip),
            analyticsSource: (0, $2491eac17b51377d$export$782903d5feb28a0a),
            isDismissLoading: isDismissLoading,
            onDismiss: ()=>dismiss(node?.id),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($aiyU2))),
            imageAltText: ""
        })));
};

});
parcelRegister("4mmGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f14472c22dd35e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3559a01d74965c9ff2c8b0dc56ab98f2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7f14472c22dd35e7$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "main_homeBroadcastWidget_Widget",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraUserBroadcastMessageConnection",
                        "kind": "LinkedField",
                        "name": "allJiraUserBroadcastMessages",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserBroadcastMessageEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraUserBroadcastMessage",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "shouldDisplay"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$7f14472c22dd35e7$var$node.hash = "940d7a80f47673c6e7419ac366f0f8c6";
var $7f14472c22dd35e7$export$2e2bcd8739ae039 = $7f14472c22dd35e7$var$node;

});

parcelRegister("8B2FA", function(module, exports) {

$parcel$export(module.exports, "PromotionalCard", () => $0bc1e5a81a25c3ea$export$418393e556a23457);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7opLA = parcelRequire("7opLA");

var $hI5oG = parcelRequire("hI5oG");

var $jWuk1 = parcelRequire("jWuk1");

var $aUqTb = parcelRequire("aUqTb");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $lSjZ9 = parcelRequire("lSjZ9");
const $0bc1e5a81a25c3ea$export$418393e556a23457 = ({ imageUrl: imageUrl, imageAltText: imageAltText, header: header, description: description, primaryAction: primaryAction, reason: reason, analyticsSource: analyticsSource, isDismissLoading: isDismissLoading, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926),
        sourceName: analyticsSource
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "subtle",
        spacing: "none",
        isLoading: isDismissLoading,
        "aria-label": formatMessage((0, $lSjZ9.default).dismiss),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            size: "medium",
            label: "",
            primaryColor: `var(--ds-icon-warning-inverse, ${(0, $PdmhA).N800})`
        }),
        onClick: (e, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `${analyticsSource}Dismiss`);
            onDismiss();
        }
    })), imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$ImageContainer, {
        imageUrl: imageUrl
    }, imageAltText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        role: "img",
        "aria-label": imageAltText
    }) : null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium",
        as: "h2"
    }, header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$Description, null, description), primaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: reason,
        onShow: (analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'promotionalCardInfo')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc1e5a81a25c3ea$var$FooterContent, {
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
        size: "small",
        label: ""
    }), formatMessage((0, $lSjZ9.default).footerContent))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bc1e5a81a25c3ea$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _16qspmv4 _2rko1l7b _1bsb1gwv _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bc1e5a81a25c3ea$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71lckbl _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bc1e5a81a25c3ea$var$ImageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { imageUrl: imageUrl, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ntxwly": (0, $9t7rW.default)(`url(${__cmplp.imageUrl})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1lrw1dfr _4t3ibv7e _1bsb1osq _1itklex0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bc1e5a81a25c3ea$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1yt4pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bc1e5a81a25c3ea$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkutpp _otyrutpp _syaz1fxt _c71l1wqb _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $0bc1e5a81a25c3ea$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _x3doh6cr _1yt418iy _syaz1wmz",
            __cmplp.className
        ])
    });
});
const $0bc1e5a81a25c3ea$var$FooterContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulp1b66 _1wyb1skh",
            __cmplp.className
        ])
    });
});
const $0bc1e5a81a25c3ea$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iv47k _1xi21ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7f13fdf9f823d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 19a7 7 0 110-14 7 7 0 010 14zm0-1.5a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0-6a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm0-3a1 1 0 110 2 1 1 0 010-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = $7f13fdf9f823d771$var$EditorPanelIcon;
module.exports.default = $7f13fdf9f823d771$var$_default;

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("lSjZ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a3a81f3c6acc15$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $49a3a81f3c6acc15$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dismiss: {
        "id": "home-common-ui.promotional-card.dismiss",
        "defaultMessage": "Close"
    },
    footerContent: {
        "id": "home-common-ui.promotional-card.footer-content",
        "defaultMessage": "Why am I seeing this?"
    }
});

});


parcelRegister("9zT4Z", function(module, exports) {

$parcel$export(module.exports, "ExternalLinkWithAnalytics", () => $876331f1a8f6d69a$export$93e72c5997ab57fb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $23NQ5 = parcelRequire("23NQ5");

var $ghwRe = parcelRequire("ghwRe");
const $876331f1a8f6d69a$export$93e72c5997ab57fb = ({ children: children, href: href, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876331f1a8f6d69a$var$InlineLinkWithAnalytics, {
        target: "_blank",
        attributes: attributes,
        href: href,
        actionSubjectId: actionSubjectId
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876331f1a8f6d69a$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
        size: "small",
        label: ""
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $876331f1a8f6d69a$var$InlineLinkWithAnalytics = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $ghwRe.LinkWithAnalytics), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $876331f1a8f6d69a$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _18u01b66 _s7n4nkob",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ghwRe", function(module, exports) {

$parcel$export(module.exports, "LinkWithAnalytics", () => $f078d49bdfd5d2e1$export$560bebe32100cf5e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");

var $kJlBc = parcelRequire("kJlBc");
const $f078d49bdfd5d2e1$export$560bebe32100cf5e = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId = '', attributes: attributes = {}, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f078d49bdfd5d2e1$var$LinkWithAnalyticsBase, {
        ...props,
        onClick: (e, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
            if (props.onClick) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            props.onClick();
        }
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f078d49bdfd5d2e1$var$Link = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng",
            __cmplp.className
        ])
    });
});
const $f078d49bdfd5d2e1$var$LinkWithAnalyticsBase = (0, $g8JvH.AnalyticsEventToProps)('link', {
    onClick: 'clicked'
})($f078d49bdfd5d2e1$var$Link);

});


parcelRegister("aiyU2", function(module, exports) {
module.exports = new URL("advanced-roadmap-broadcast-image.09b197f3.svg", import.meta.url).toString();

});

parcelRegister("61Upl", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd224b2329c4bbb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bbd224b2329c4bbb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "home-broadcast-widget.header",
        "defaultMessage": "Agile planning at scale"
    },
    cardDescription: {
        "id": "home-broadcast-widget.card-description",
        "defaultMessage": "Track progress and make real-time changes using Plans."
    },
    ctaLink: {
        "id": "home-broadcast-widget.cta-link",
        "defaultMessage": "Start your free trial"
    },
    footerTooltip: {
        "id": "home-broadcast-widget.footer-tooltip",
        "defaultMessage": "Many people in your organization use the Timeline view. We think you\u2019d find value in a cross-team planning tool like Plans, which is part of Jira Premium."
    }
});

});

parcelRegister("adN3r", function(module, exports) {

$parcel$export(module.exports, "useDismissBroadcast", () => $47c5ee62b1127862$export$e2db3b946fbe4082);

var $2XI5S = parcelRequire("2XI5S");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $4GyaW = parcelRequire("4GyaW");

const $47c5ee62b1127862$export$e2db3b946fbe4082 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [commit, isInFlight] = (0, $iWLL0.useMutation)((0, $2XI5S.default));
    const dismiss = (0, $eUqFw.useCallback)((id)=>{
        commit({
            variables: {
                cloudId: cloudId,
                id: id
            },
            onCompleted: (data)=>{
                const isSuccess = Boolean(data.jira?.setUserBroadcastMessageDismissed?.success);
                // We only care about first error
                const error = (data.jira?.setUserBroadcastMessageDismissed?.errors ?? [])[0];
                if (!isSuccess || error) {
                    const errorMessage = `error on dismiss jira home broadcast widget: ${error?.message}`;
                    const statusCode = error?.extensions?.statusCode;
                    (0, $guiFP.default)({
                        error: new Error(`status code: ${statusCode ?? 'unknown'}, ${errorMessage}`),
                        meta: {
                            id: (0, $2491eac17b51377d$export$b0557d7f6549d5d6),
                            packageName: (0, $2491eac17b51377d$export$b8b9d90f9e5bd72b),
                            teamName: (0, $2491eac17b51377d$export$d57b6b390e78d90f)
                        }
                    });
                    showFlag((0, $4GyaW.getErrorFlagOnDismiss)());
                }
            },
            onError: (error)=>{
                (0, $guiFP.default)({
                    error: new Error(`${(0, $2491eac17b51377d$export$3cf048f5f09bc0bd)} with ${error.message}`),
                    meta: {
                        id: (0, $2491eac17b51377d$export$3cf048f5f09bc0bd),
                        packageName: (0, $2491eac17b51377d$export$b8b9d90f9e5bd72b),
                        teamName: (0, $2491eac17b51377d$export$d57b6b390e78d90f)
                    }
                });
                showFlag((0, $4GyaW.getErrorFlagOnDismiss)());
            }
        });
    }, [
        cloudId,
        commit,
        showFlag
    ]);
    return {
        dismiss: dismiss,
        isDismissLoading: isInFlight
    };
};

});
parcelRegister("2XI5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $61843600116afd0b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0d29bc6424413b7e2c2b36640203dfff>>
 * @relayHash a610b905458276697a08cac8bbbcd493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 790945dcea1def559514b63e007b4ef1b0eda94825738e19c758129607fba901
const $61843600116afd0b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "concreteType": "JiraUserBroadcastMessage",
        "kind": "LinkedField",
        "name": "userBroadcastMessage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "shouldDisplay"
            },
            {
                "kind": "ScalarField",
                "name": "isDismissed"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_homeBroadcastDismiss_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserBroadcastMessageActionPayload",
                            "kind": "LinkedField",
                            "name": "setUserBroadcastMessageDismissed",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_homeBroadcastDismiss_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserBroadcastMessageActionPayload",
                            "kind": "LinkedField",
                            "name": "setUserBroadcastMessageDismissed",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "790945dcea1def559514b63e007b4ef1b0eda94825738e19c758129607fba901",
            "metadata": {},
            "name": "main_homeBroadcastDismiss_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$61843600116afd0b$var$node.hash = "f4b819af49c1e5fd15d1c6393f5cc1ca";
var $61843600116afd0b$export$2e2bcd8739ae039 = $61843600116afd0b$var$node;

});

parcelRegister("4GyaW", function(module, exports) {

$parcel$export(module.exports, "getErrorFlagOnDismiss", () => $116fe03bb2edb558$export$345f933fc1cda2e3);

var $eo17r = parcelRequire("eo17r");


var $5skv5 = parcelRequire("5skv5");
const $116fe03bb2edb558$export$345f933fc1cda2e3 = ()=>({
        key: (0, $eo17r.toFlagId)((0, $2491eac17b51377d$export$33f599f0fcf9ffb1)),
        type: 'error',
        title: (0, $5skv5.messages).title,
        description: (0, $5skv5.messages).description
    });

});
parcelRegister("5skv5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8ece883cbe887637$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8ece883cbe887637$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "home-broadcast-widget.common.flags.title",
        "defaultMessage": "We couldn't dismiss the recommendation"
    },
    description: {
        "id": "home-broadcast-widget.common.flags.description",
        "defaultMessage": "Refresh your page and try again."
    }
});

});





parcelRegister("5cOjU", function(module, exports) {

$parcel$export(module.exports, "NbaExperimentCards", () => $0aeed51b63f1bf18$export$9413b38aa8e03d23);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jG1wZ = parcelRequire("jG1wZ");

var $98alr = parcelRequire("98alr");
var $bGOis = parcelRequire("bGOis");

var $WYb5n = parcelRequire("WYb5n");
var $fQNrS = parcelRequire("fQNrS");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4QQfT = parcelRequire("4QQfT");

var $8KfZV = parcelRequire("8KfZV");

var $hZTXN = parcelRequire("hZTXN");

var $2cpxE = parcelRequire("2cpxE");

var $4jUNj = parcelRequire("4jUNj");
const $0aeed51b63f1bf18$export$59460b87001b239 = ({ AdControls: AdControls = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null), onTryNowClick: onTryNowClick, onLearnMoreClick: onLearnMoreClick, onInviteUserClick: onInviteUserClick, showCrossflowMessage: showCrossflowMessage, showExpansionMessage: showExpansionMessage, onDismissCrossflowMessage: onDismissCrossflowMessage, onDismissExpansionMessage: onDismissExpansionMessage, isSiteAdmin: isSiteAdmin })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, showCrossflowMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4QQfT.JiraYourWorkNextBestActionMessage), {
        AdControls: AdControls,
        onTryNowClick: onTryNowClick,
        onLearnMoreClick: onLearnMoreClick,
        onDismissCrossflowMessage: onDismissCrossflowMessage,
        isSiteAdmin: isSiteAdmin
    }) : null, showExpansionMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hZTXN.InviteUserMessage), {
        onInviteUserClick: onInviteUserClick,
        onDismissExpansionMessage: onDismissExpansionMessage
    }) : null);
const $0aeed51b63f1bf18$export$112d8d745d9559c5 = (props)=>// We can run A/A Test and roll out the feature to 100% at the same time
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $eI5EY.fg)('jira_your_work_recommendations_native') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0aeed51b63f1bf18$export$59460b87001b239, props));
const $0aeed51b63f1bf18$var$NbaExperimentCards = ()=>{
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin, openCrossFlow: openCrossFlow, isCrossflowMessageVisible: isCrossflowMessageVisible, isExpansionMessageVisible: isExpansionMessageVisible, dimissExpansionMessage: dimissExpansionMessage, dismissCrossflowMessage: dismissCrossflowMessage, contextResolver: contextResolver, cohort: cohort, onLearnMoreClick: onLearnMoreClick } = (0, $2cpxE.useJiraYourWorkExperiment)();
    const { openModal: openModal } = (0, $fQNrS.useInvitePeopleModal)({
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        subProduct: 'product-discovery',
        enableThirdParty: true,
        source: (0, $4jUNj.EXPERIMENT_ID)
    });
    const fireTryNowAnalyticsEvent = (0, $4jUNj.useFireUCIAButtonEvent)({
        eventName: 'tryNow',
        cohort: cohort
    });
    const fireLearnMoreAnalyticsEvent = (0, $4jUNj.useFireUCIAButtonEvent)({
        eventName: 'learnMore',
        cohort: cohort
    });
    const fireAddTeamMembersAnalyticsEvent = (0, $4jUNj.useFireButtonClickEvent)({
        eventName: 'addTeamMembers',
        cohort: cohort
    });
    const fireReasonsAnalyticsEvent = (0, $4jUNj.useFireButtonClickEvent)({
        eventName: 'adControlsReasons',
        cohort: cohort
    });
    if (cohort === 'control' || cohort === 'not-enrolled') return null;
    const handleOnTryNowClicked = ()=>{
        fireTryNowAnalyticsEvent();
        return openCrossFlow();
    };
    const handleOnInviteUserClicked = ()=>{
        fireAddTeamMembersAnalyticsEvent();
        openModal();
    };
    const handleOnLearnMoreClicked = ()=>{
        fireLearnMoreAnalyticsEvent();
        return onLearnMoreClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bGOis.default), {
        contextResolver: contextResolver,
        onEvents: ({ type: type })=>{
            if (type === 'DISMISS_STARTED') dismissCrossflowMessage();
            else if (type === 'REASONS_BUTTON_CLICKED') fireReasonsAnalyticsEvent();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0aeed51b63f1bf18$export$112d8d745d9559c5, {
        onDismissCrossflowMessage: dismissCrossflowMessage,
        onDismissExpansionMessage: dimissExpansionMessage,
        AdControls: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $98alr.default), {
                productId: (0, $2cpxE.JIRA_PRODUCT_DISCOVERY_PRODUCT_ID),
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        ...props,
                        spacing: "compact",
                        appearance: "subtle",
                        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                            label: "more",
                            size: "medium"
                        }),
                        ref: triggerRef
                    }),
                name: "Jira Product Discovery",
                reasons: [
                    'the size of your team',
                    'your existing Atlassian products'
                ]
            }),
        onInviteUserClick: handleOnInviteUserClicked,
        onLearnMoreClick: handleOnLearnMoreClicked,
        onTryNowClick: handleOnTryNowClicked,
        showCrossflowMessage: isCrossflowMessageVisible,
        showExpansionMessage: isExpansionMessageVisible,
        isSiteAdmin: isSiteAdmin
    }));
};
const $0aeed51b63f1bf18$export$9413b38aa8e03d23 = ()=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    if (!locale.includes('en')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8KfZV.ErrorBoundary), {
        errorId: "trailblazer.nbaexperiment.wrappednbaexperimentcards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $WYb5n.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0aeed51b63f1bf18$var$NbaExperimentCards, null)));
};
var $0aeed51b63f1bf18$export$2e2bcd8739ae039 = $0aeed51b63f1bf18$export$112d8d745d9559c5;

});
parcelRegister("4QQfT", function(module, exports) {

$parcel$export(module.exports, "JiraYourWorkNextBestActionMessage", () => $cb3da508906c15ac$export$1510cc2a2d611eec);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $lkO3b = parcelRequire("lkO3b");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4q38b = parcelRequire("4q38b");

var $3lROm = parcelRequire("3lROm");
const $cb3da508906c15ac$export$1510cc2a2d611eec = ({ onTryNowClick: onTryNowClick, onLearnMoreClick: onLearnMoreClick, AdControls: AdControls, isSiteAdmin: isSiteAdmin })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const isDarkMode = colorMode === 'dark';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb3da508906c15ac$var$MessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb3da508906c15ac$var$MessageHeader, {
        isDarkMode: isDarkMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        alt: "Jira Product Discovery",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3lROm)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb3da508906c15ac$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AdControls, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cb3da508906c15ac$var$messageContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkO3b.JiraProductDiscoveryLogo), {
        appearance: "brand",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb3da508906c15ac$var$MessageTitle, null, "Build right features, the right way"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb3da508906c15ac$var$MessageDescription, null, "Prioritize your ideas then easily move them into delivery, without losing any details on the way."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cb3da508906c15ac$var$messageFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb3da508906c15ac$var$StyledButton, {
        onClick: onTryNowClick
    }, isSiteAdmin ? 'Try it now' : 'Request to try'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onLearnMoreClick,
        appearance: "subtle"
    }, "Learn more"))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb3da508906c15ac$var$MessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1gwv _4t3i1mjv _bfhk1j9a _2rko1l7b _otyrpxbi _16qs7bxk",
            __cmplp.className
        ])
    });
});
const $cb3da508906c15ac$var$messageFooterStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb3da508906c15ac$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $cb3da508906c15ac$var$MessageDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1aqp _19pku2gc _1wybdlk8 _zg8l4jg8 _k48p1nn1 _vwz4gktf",
            __cmplp.className
        ])
    });
});
const $cb3da508906c15ac$var$MessageTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _1bsbsb0t _1wybgktf _zg8l4jg8 _k48pbfng _vwz41tcg",
            __cmplp.className
        ])
    });
});
const $cb3da508906c15ac$var$messageContentStyles = (0, $1ZAYh.xcss)({
    padding: 'space.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb3da508906c15ac$var$MessageHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDarkMode: isDarkMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3iv7uf _2rko1k7a _1bah1y6m _4cvr1h6o _1e0c1txw",
            __cmplp.isDarkMode ? "_bfhk1mem" : "_bfhk1wsd",
            __cmplp.className
        ])
    });
});
const $cb3da508906c15ac$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iutpp _1xi2utpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3lROm", function(module, exports) {
module.exports = new URL("jpd-header.4a95c371.svg", import.meta.url).toString();

});


parcelRegister("8KfZV", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $2a924bb8542c5e7e$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $guiFP = parcelRequire("guiFP");
const $2a924bb8542c5e7e$export$e926676385687eaf = ({ children: children, errorId: errorId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        onError: (_, error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: errorId
                },
                error: error
            });
        }
    }, children);

});

parcelRegister("hZTXN", function(module, exports) {

$parcel$export(module.exports, "InviteUserMessage", () => $3432f2126886b414$export$1cdb20c6a8643ec9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $lkO3b = parcelRequire("lkO3b");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4q38b = parcelRequire("4q38b");

var $9ZkPH = parcelRequire("9ZkPH");
const $3432f2126886b414$export$1cdb20c6a8643ec9 = ({ onInviteUserClick: onInviteUserClick, onDismissExpansionMessage: onDismissExpansionMessage })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const isDarkMode = colorMode === 'dark';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3432f2126886b414$var$MessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3432f2126886b414$var$MessageHeader, {
        isDarkMode: isDarkMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3432f2126886b414$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onDismissExpansionMessage,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: "dismiss",
            size: "medium"
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        alt: "Jira Product Discovery",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9ZkPH)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3432f2126886b414$var$messageContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkO3b.JiraProductDiscoveryLogo), {
        appearance: "brand",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3432f2126886b414$var$MessageTitle, null, "Add your team to help collect and prioritize ideas "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3432f2126886b414$var$MessageDescription, null, "Collate, prioritize and deliver ideas all on one platform, together."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3432f2126886b414$var$messageFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onInviteUserClick
    }, "Add team members"))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3432f2126886b414$var$MessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1gwv _4t3i1mjv _bfhk1j9a _2rko1l7b _otyrpxbi _kqswh2mm _16qs7bxk",
            __cmplp.className
        ])
    });
});
const $3432f2126886b414$var$messageFooterStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3432f2126886b414$var$MessageTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _1bsbsb0t _1wybgktf _zg8l4jg8 _k48pbfng _vwz41tcg",
            __cmplp.className
        ])
    });
});
const $3432f2126886b414$var$MessageDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1aqp _19pku2gc _1wybdlk8 _zg8l4jg8 _k48p1nn1 _vwz4gktf",
            __cmplp.className
        ])
    });
});
const $3432f2126886b414$var$MessageHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDarkMode: isDarkMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1uc6 _2rko1k7a _1bah1h6o _4cvr1h6o _1e0c1txw",
            __cmplp.isDarkMode ? "_bfhk1mem" : "_bfhk1wsd",
            __cmplp.className
        ])
    });
});
const $3432f2126886b414$var$messageContentStyles = (0, $1ZAYh.xcss)({
    padding: 'space.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3432f2126886b414$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iutpp _1xi2utpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9ZkPH", function(module, exports) {
module.exports = new URL("avatar-group.76f9cf92.svg", import.meta.url).toString();

});


parcelRegister("2cpxE", function(module, exports) {

$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_PRODUCT_ID", () => $31c12aa5651df1a4$export$5cd3d54d716f9878);
$parcel$export(module.exports, "useJiraYourWorkExperiment", () => $31c12aa5651df1a4$export$f6ecbdac07e85d49);

var $eUqFw = parcelRequire("eUqFw");

var $NYVfB = parcelRequire("NYVfB");

var $j0S5V = parcelRequire("j0S5V");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $dWlsy = parcelRequire("dWlsy");

var $gd0Sp = parcelRequire("gd0Sp");

var $4jUNj = parcelRequire("4jUNj");
const $31c12aa5651df1a4$var$SOURCE_COMPONENT = 'jiraYourWorkRecommendationsExperiment';
const $31c12aa5651df1a4$export$5cd3d54d716f9878 = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
// localStorage keys
const $31c12aa5651df1a4$var$CROSSFLOW_MESSAGE_KEY = 'crossflow_message_is_dismissed';
const $31c12aa5651df1a4$var$EXPANSION_MESSAGE_KEY = 'expansion_message_is_dismissed';
const $31c12aa5651df1a4$var$PRODUCT_PROVISIONED_KEY = 'product_provisioned';
const $31c12aa5651df1a4$var$PRODUCT_PROVISIONED_TIME_STAMP = 'product_provisioned_time_stamp';
const $31c12aa5651df1a4$export$f6ecbdac07e85d49 = ()=>{
    const crossFlow = (0, $NYVfB.useCrossFlow)();
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin, atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const subProduct = (0, $dWlsy.useSubProduct)();
    const contextResolver = (0, $eUqFw.useMemo)(()=>({
            tenantId: cloudId,
            product: 'jira',
            useCase: 'jira-your-work',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            subproduct: subProduct
        }), [
        cloudId,
        subProduct
    ]);
    // Message Visibility
    const [isCrossflowMessageVisible, setIsCrossflowMessageVisible] = (0, $eUqFw.useState)(false);
    const [isExpansionMessageVisible, setIsExpansionMessageVisible] = (0, $eUqFw.useState)(false);
    const showCrossflowMessage = ()=>setIsCrossflowMessageVisible(true);
    const showExpansionMessage = ()=>setIsExpansionMessageVisible(true);
    const hideCrossflowMessage = ()=>setIsCrossflowMessageVisible(false);
    const hideExpansionMessage = ()=>setIsExpansionMessageVisible(false);
    const cohort = (0, $79xbN.expVal)('jira_your_work_recommendations_nba', 'cohort', 'not-enrolled');
    // Analytic events
    const fireDismissExpansionCardAnalyticsEvent = (0, $4jUNj.useFireButtonClickEvent)({
        eventName: 'dissmissExpansionCard',
        cohort: cohort
    });
    const fireNotInterestedAnalyticsEvent = (0, $4jUNj.useFireButtonClickEvent)({
        eventName: 'notInterested',
        cohort: cohort
    });
    // On Dimissal
    const dismissCrossflowMessage = ()=>{
        fireNotInterestedAnalyticsEvent();
        try {
            localStorage.setItem($31c12aa5651df1a4$var$CROSSFLOW_MESSAGE_KEY, `${atlassianAccountId}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'trailblazer.nbaexperiment.dismissCrossflowMessage'
                },
                error: error
            });
        }
        hideCrossflowMessage();
    };
    const dimissExpansionMessage = ()=>{
        fireDismissExpansionCardAnalyticsEvent();
        try {
            localStorage.setItem($31c12aa5651df1a4$var$EXPANSION_MESSAGE_KEY, `${atlassianAccountId}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'trailblazer.nbaexperiment.dimissExpansionMessage'
                },
                error: error
            });
        }
        hideExpansionMessage();
    };
    const onProductProvisionedByUser = ()=>{
        localStorage.setItem(`${$31c12aa5651df1a4$var$PRODUCT_PROVISIONED_KEY}-${cloudId}`, `${atlassianAccountId}`);
        localStorage.setItem(`${$31c12aa5651df1a4$var$PRODUCT_PROVISIONED_TIME_STAMP}-${cloudId}`, `${Date.now()}`);
        hideCrossflowMessage();
    };
    const isCrossflowMessageDismissed = ()=>localStorage.getItem($31c12aa5651df1a4$var$CROSSFLOW_MESSAGE_KEY) === atlassianAccountId;
    const isExpansionMessageDismissed = ()=>localStorage.getItem($31c12aa5651df1a4$var$EXPANSION_MESSAGE_KEY) === atlassianAccountId;
    const fireExposureEventOnce = (0, $4jUNj.useFireExposureEventOnce)();
    const isProductProvisionedByUser = ()=>{
        const productInstalledByUserId = localStorage.getItem(`${$31c12aa5651df1a4$var$PRODUCT_PROVISIONED_KEY}-${cloudId}`);
        if (productInstalledByUserId && productInstalledByUserId === atlassianAccountId) {
            const now = Date.now();
            const twoDays = 172800000;
            const productProvisioningTime = Number(localStorage.getItem(`${$31c12aa5651df1a4$var$PRODUCT_PROVISIONED_TIME_STAMP}-${cloudId}`));
            const twoDaysAfterProvisioning = twoDays + productProvisioningTime;
            return twoDaysAfterProvisioning < now;
        }
        return false;
    };
    const { getRecommendations: getRecommendations } = (0, $j0S5V.default)({
        contextResolver: contextResolver
    });
    (0, $eUqFw.useEffect)(()=>{
        const getJpdStatus = async ()=>{
            try {
                const recommendations = await getRecommendations(3);
                if (recommendations.response && recommendations.response.data) {
                    let isExpansionCardVisible = false;
                    let isCrossflowCardVisible = false;
                    // JPD will not be recommended if JPD is installed on site or user dismissed it
                    const isJpdRecommended = recommendations.response.data.some((recommendation)=>recommendation.entityId === $31c12aa5651df1a4$export$5cd3d54d716f9878);
                    if (isJpdRecommended) {
                        showCrossflowMessage();
                        isCrossflowCardVisible = true;
                    } else if (!isCrossflowMessageDismissed() && !isExpansionMessageDismissed() && isProductProvisionedByUser()) {
                        showExpansionMessage();
                        isExpansionCardVisible = true;
                    }
                    const cardVersion = $31c12aa5651df1a4$var$getCardVersionName({
                        cohort: cohort,
                        isCrossflowMessageVisible: isCrossflowCardVisible,
                        isExpansionMessageVisible: isExpansionCardVisible
                    });
                    fireExposureEventOnce({
                        cohort: cohort,
                        cardVersion: cardVersion
                    });
                } else fireExposureEventOnce({
                    cohort: cohort,
                    cardVersion: 'null-card-missing-data'
                });
            } catch (error) {
                fireExposureEventOnce({
                    cohort: cohort,
                    cardVersion: 'null-card-error'
                });
            }
        };
        if (cohort === 'experiment') getJpdStatus();
        else if (cohort === 'control') fireExposureEventOnce({
            cohort: cohort,
            cardVersion: 'null-card-control'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onLearnMoreClick = async ()=>{
        if (crossFlow.isEnabled) try {
            const crossflowResult = await crossFlow.api.open({
                journey: (0, $NYVfB.Journeys).DECIDE,
                sourceComponent: $31c12aa5651df1a4$var$SOURCE_COMPONENT,
                sourceContext: 'learnMore',
                targetProduct: 'jira-product-discovery'
            });
            if (crossflowResult.success === true) // save time stamp in local storage after product is installed
            onProductProvisionedByUser();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'trailblazer.nbaexperiment.onLearnMoreClick'
                },
                error: error
            });
        }
    };
    const openCrossFlow = async ()=>{
        if (crossFlow.isEnabled) try {
            const crossflowResult = await crossFlow.api.open({
                journey: (0, $NYVfB.Journeys).GET_STARTED,
                sourceComponent: $31c12aa5651df1a4$var$SOURCE_COMPONENT,
                sourceContext: 'tryNow',
                targetProduct: 'jira-product-discovery'
            });
            if (crossflowResult.success === true) // save time stamp in local storage after product is installed
            onProductProvisionedByUser();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'trailblazer.nbaexperiment.openCrossFlow'
                },
                error: error
            });
        }
    };
    return {
        cloudId: cloudId,
        isSiteAdmin: isSiteAdmin,
        openCrossFlow: openCrossFlow,
        isCrossflowMessageVisible: isCrossflowMessageVisible,
        isExpansionMessageVisible: isExpansionMessageVisible,
        dismissCrossflowMessage: dismissCrossflowMessage,
        dimissExpansionMessage: dimissExpansionMessage,
        contextResolver: contextResolver,
        cohort: cohort,
        onLearnMoreClick: onLearnMoreClick
    };
};
const $31c12aa5651df1a4$var$getCardVersionName = ({ isCrossflowMessageVisible: isCrossflowMessageVisible, isExpansionMessageVisible: isExpansionMessageVisible, cohort: cohort })=>{
    if (cohort === 'control') return 'null-card-control';
    if (isCrossflowMessageVisible) return 'cross-flow';
    if (isExpansionMessageVisible) return 'expansion';
    // between cross flow and expansion period
    return 'null-card-waiting-period';
};

});
parcelRegister("4jUNj", function(module, exports) {

$parcel$export(module.exports, "EXPERIMENT_ID", () => $92ad61bd584d4202$export$2db94204630af4ab);
$parcel$export(module.exports, "useFireExposureEventOnce", () => $92ad61bd584d4202$export$7da461a3112d3669);
$parcel$export(module.exports, "useFireButtonClickEvent", () => $92ad61bd584d4202$export$311ff86586e6013b);
$parcel$export(module.exports, "useFireUCIAButtonEvent", () => $92ad61bd584d4202$export$b58522bdcbeb9f3);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8fAH0 = parcelRequire("8fAH0");
var $a0eNT = parcelRequire("a0eNT");
const $92ad61bd584d4202$export$2db94204630af4ab = 'jira_your_work_recommendations_nba';
const $92ad61bd584d4202$var$env = 'prod';
const $92ad61bd584d4202$var$JIRA_PRODUCT_DISCOVERY_CCP_PRODUCT_ID = (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[$92ad61bd584d4202$var$env].jira_product_discovery;
const $92ad61bd584d4202$export$7da461a3112d3669 = ()=>{
    const { fireViewedUIEvent: fireViewedUIEvent } = (0, $a0eNT.useFireCrossFlowAnalyticsEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isFired = (0, $eUqFw.useRef)(false);
    return ({ cohort: cohort, cardVersion: cardVersion })=>{
        if ((cohort === 'control' || cohort === 'experiment') && !isFired.current) {
            if (cardVersion === 'cross-flow') fireViewedUIEvent({
                action: 'viewed',
                actionSubject: 'card',
                actionSubjectId: 'jiraYourWorkRecommendationsExperiment'
            }, {
                recommendedProductIds: [
                    $92ad61bd584d4202$var$JIRA_PRODUCT_DISCOVERY_CCP_PRODUCT_ID
                ],
                source: 'jiraYourWorkRecommendationsExperiment'
            }, {
                cohort: cohort,
                cardVersion: cardVersion,
                growthInitiative: 'cross-flow',
                flagKey: $92ad61bd584d4202$export$2db94204630af4ab
            });
            else (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'feature',
                action: 'exposed'
            }), 'feature exposed', {
                cohort: cohort,
                exposedTo: cardVersion
            });
            isFired.current = true;
        }
    };
};
const $92ad61bd584d4202$export$311ff86586e6013b = ({ eventName: eventName, cohort: cohort })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), eventName, {
            growthInitiative: 'cross-flow',
            flagKey: $92ad61bd584d4202$export$2db94204630af4ab,
            cohort: cohort
        });
};
const $92ad61bd584d4202$export$b58522bdcbeb9f3 = ({ eventName: eventName, cohort: cohort })=>{
    const { fireInteractedUIEvent: fireInteractedUIEvent } = (0, $a0eNT.useFireCrossFlowAnalyticsEvents)();
    return ()=>fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: eventName
        }, {
            recommendedProductIds: [
                $92ad61bd584d4202$var$JIRA_PRODUCT_DISCOVERY_CCP_PRODUCT_ID
            ],
            targetProductId: $92ad61bd584d4202$var$JIRA_PRODUCT_DISCOVERY_CCP_PRODUCT_ID,
            source: 'jiraYourWorkRecommendationsExperimentCard'
        }, {
            cohort: cohort,
            growthInitiative: 'cross-flow',
            flagKey: $92ad61bd584d4202$export$2db94204630af4ab
        });
};

});



parcelRegister("7QPhl", function(module, exports) {

$parcel$export(module.exports, "JiraHomeSidePanelSkipLink", () => $5348da654fb357f2$export$43e60633aac6e635);

var $5JgJ2 = parcelRequire("5JgJ2");

var $hwyJ1 = parcelRequire("hwyJ1");

var $cbMtb = parcelRequire("cbMtb");
const $5348da654fb357f2$export$43e60633aac6e635 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $hwyJ1.useCustomSkipLink)('jira-home-side-panel', formatMessage((0, $cbMtb.default).skipToRightSidePanel), 4);
    return null;
};

});
parcelRegister("cbMtb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aeee0003a1b8207$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1aeee0003a1b8207$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    skipToRightSidePanel: {
        "id": "home-right-side-panel.skip-link.skip-to-right-side-panel",
        "defaultMessage": "Skip to Side Panel"
    }
});

});






//# sourceMappingURL=async-jira-home-right-side-panel.56aa350a.js.map
